import styled from "styled-components";
import { Title } from "../../../kanopy-ui/Texts/Texts";

export const TitleStyled = styled(Title)`
   margin-top: 16px;
   padding-top: 5px;
`;
